module.exports = __webpack_public_path__ + "img/109607.37d74dfc.svg";